import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { typeEstruturaTodasAtvs } from './index';
import { HeaderDef } from './gerarPDFPlanejamentoInsumos';
import { logo_ttivos_base64 } from '../../../../../../../Components/GerarExcel/meta';
import secureLocalStorage from "react-secure-storage";

export const gerarExcelPlanejamentoInsumos = async (
    dados: typeEstruturaTodasAtvs[],
    headerInfo?: HeaderDef
) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Planejamento de Insumos', {
        views: [{ showGridLines: false }]
    });

    worksheet.columns = [
        { header: '', key: 'col1', width: 30 }, // Atividade
        { header: '', key: 'col2', width: 30 }, // Insumo
        { header: '', key: 'col3', width: 15 }, // Tipo
        { header: '', key: 'col4', width: 10 }, // Remonte
        { header: '', key: 'col5', width: 15 }, // Dosagem
        { header: '', key: 'col6', width: 20 }, // Quantidade
    ];

    let currentRow = 1;

    // ** HEADER **
    worksheet.getRow(currentRow).height = 40; // Linha para a imagem
    worksheet.getRow(currentRow + 1).height = 30; // Linha para o título
    worksheet.getRow(currentRow + 2).height = 20; // Linha para razao social

    // LOGO
    const headerImageId = workbook.addImage({
        base64: logo_ttivos_base64,
        extension: 'png',
    });

    worksheet.addImage(headerImageId, {
        tl: { col: 2.2, row: 0 },
        ext: { width: 121, height: 50 },
        editAs: 'LOGO TTIVOS'
    });
    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const logoRow = worksheet.getRow(currentRow);
    logoRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    for (let i = 1; i <= 6; i++) {
        logoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const titleRow = worksheet.getRow(currentRow);
    titleRow.getCell(1).value = headerInfo?.titulo || 'Relatório de Planejamento de Insumos';
    titleRow.getCell(1).font = { size: 16, bold: true };
    titleRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        titleRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;
    worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
    const razaoRow = worksheet.getRow(currentRow);
    razaoRow.getCell(1).value = headerInfo?.razaoSocial || '';
    razaoRow.getCell(1).font = { size: 10 };
    razaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
    for (let i = 1; i <= 6; i++) {
        razaoRow.getCell(i).border = {
            bottom: { style: 'thin', color: { argb: 'FFD3D3D3' } }
        };
    }
    currentRow++;

    // ** CLIENTE **
    if (headerInfo?.cliente) {
        worksheet.getRow(currentRow).height = 10; // Espaçamento superior
        currentRow++;

        worksheet.getRow(currentRow).height = 20;
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const clienteRow = worksheet.getRow(currentRow);
        clienteRow.getCell(1).value = `Cliente: ${headerInfo.cliente}`;
        clienteRow.getCell(1).font = { size: 12, bold: true };
        clienteRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
        currentRow++;
    }

    currentRow++; // linha vazia

    const applyBorders = (rowNum: number, color = 'FF000000') => {
        const row = worksheet.getRow(rowNum);
        for (let i = 1; i <= 6; i++) {
            row.getCell(i).border = {
                top: { style: 'thin', color: { argb: color } },
                left: { style: 'thin', color: { argb: color } },
                bottom: { style: 'thin', color: { argb: color } },
                right: { style: 'thin', color: { argb: color } }
            };
        }
    };

    dados.forEach((propriedade) => {
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const propRow = worksheet.getRow(currentRow);
        propRow.getCell(1).value = propriedade.nome_propriedade || "PROPRIEDADE NÃO INFORMADA";
        propRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 12 };
        propRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF5DA57D' } };
        propRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
        propRow.height = 25;
        applyBorders(currentRow, 'FF165C13');
        currentRow++;

        propriedade.lista_insumos_por_talhao.forEach((talhao) => {
            worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
            const talhaoRow = worksheet.getRow(currentRow);
            talhaoRow.getCell(1).value = `${talhao.nome_talhao || "TALHÃO NÃO INFORMADO"} - ${talhao.area || 0} ha`;
            talhaoRow.getCell(1).font = { bold: true, color: { argb: 'FF165C13' }, size: 11 };
            talhaoRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            talhaoRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
            talhaoRow.height = 20;
            applyBorders(currentRow, 'FF165C13');
            currentRow++;

            const headerTitles = ['Atividade', 'Insumo', 'Tipo', 'Remonte', 'Dosagem', 'Quantidade'];
            const colHeaderRow = worksheet.getRow(currentRow);
            headerTitles.forEach((title, index) => {
                const cell = colHeaderRow.getCell(index + 1);
                cell.value = title;
                cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF0E743F' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
            });
            colHeaderRow.height = 20;
            applyBorders(currentRow, 'FF000000');
            currentRow++;

            let globalInsumoIndex = 0;

            talhao.lista_insumos.forEach((insu) => {
                const zebraColor = (globalInsumoIndex % 2 === 0) ? 'FFFFFFFF' : 'FFE5F1E1';

                const remonteStr = typeof insu.porcentagem_remonte === 'number' && insu.porcentagem_remonte > 0
                    ? `${insu.porcentagem_remonte}%`
                    : typeof insu.porcentagem_remonte === 'number' ? `0%` : '-';

                const atvRow = worksheet.getRow(currentRow);
                atvRow.getCell(1).value = insu.descricao_atv || '-';
                atvRow.getCell(2).value = insu.insumo_nome || '-';
                atvRow.getCell(3).value = insu?.tipo_nome || '-';
                atvRow.getCell(4).value = remonteStr;
                atvRow.getCell(5).value = `${insu.dosagem || 0} ${insu.nome_medida || ''}/ha`;
                atvRow.getCell(6).value = insu.quantidade_insumo || '-';

                atvRow.height = 25;

                for (let i = 1; i <= 6; i++) {
                    const cell = atvRow.getCell(i);
                    cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
                    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: zebraColor } };
                }

                applyBorders(currentRow, 'FF000000');
                currentRow++;
                globalInsumoIndex++;
            });

            if (talhao.lista_insumos.length === 0) {
                worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
                const emptyRow = worksheet.getRow(currentRow);
                emptyRow.getCell(1).value = 'Nenhum insumo planejado para este talhão.';
                emptyRow.getCell(1).font = { italic: true };
                emptyRow.getCell(1).alignment = { horizontal: 'center', vertical: 'middle' };
                emptyRow.height = 25;
                applyBorders(currentRow, 'FF000000');
                currentRow++;
            }

            currentRow++; // empty space between talhoes
        });
        currentRow++; // empty space between propriedades
    });

    // ** FOOTER **
    const espacoRow = worksheet.addRow([]);
    espacoRow.height = 20;

    const email_usuario_logado = secureLocalStorage.getItem('Itens')?.[0]?.email?.toLowerCase() || '';
    const footerRow = worksheet.addRow([]);
    footerRow.getCell(1).value = `Gerado por: ${email_usuario_logado} - ${dayjs().format('DD/MM/YYYY HH:mm:ss')}`;
    footerRow.font = { italic: true };
    footerRow.alignment = { horizontal: 'center', vertical: 'middle' };

    for (let i = 1; i <= 6; i++) {
        worksheet.getCell(`${String.fromCharCode(64 + i)}${footerRow.number}`).border = {
            top: { style: 'thin', color: { argb: '5da57d' } }
        };
    }
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);
    footerRow.height = 25;

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer as BlobPart], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, `Relatorio_Planejamento_Insumos_${dayjs().format("DD_MM_YYYY_HH_mm")}.xlsx`);
};
